import { useState } from 'react';
import { useForm } from 'react-hook-form';
import emailjs from '@emailjs/browser';
import { Container, Row, Col } from 'react-bootstrap';
import {
  AiFillGithub,
  AiOutlineTwitter,
  AiFillInstagram,
  AiFillMail
} from "react-icons/ai";
import { FaLinkedinIn } from "react-icons/fa";

const ContactForm = () => {
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm();

  const [disabled, setDisabled] = useState(false);
  const [submittedOnce, setSubmittedOnce] = useState(false);
  const [alertInfo, setAlertInfo] = useState({
    display: false,
    message: '',
    type: '',
  });

  const toggleAlert = (message, type) => {
    setAlertInfo({ display: true, message, type });
    setTimeout(() => {
      setAlertInfo({ display: false, message: '', type: '' });
    }, 5000);
  };

  const onSubmit = async (data) => {
    if (submittedOnce) return; // Prevent double send
    setSubmittedOnce(true);

    const { name, email, subject, message } = data;
    const templateParams = { name, email, subject, message };
    const autoReplyParams = {
      to_email: email,  // The user's email
      name,             // The user's name
    };

    try {
      setDisabled(true);

      // Use environment variables from Vercel
      const serviceId = process.env.REACT_APP_EMAILJS_SERVICE_ID;
      const templateId = process.env.REACT_APP_EMAILJS_TEMPLATE_ID;
      const publicKey = process.env.REACT_APP_EMAILJS_PUBLIC_KEY;

      await emailjs.send(serviceId, templateId, templateParams, publicKey);
      await emailjs.send(serviceId, 'template_n4i9s7i', autoReplyParams, publicKey);
      toggleAlert('Message Sent Successfully!', 'success');
    } catch (e) {
      console.error(e);
      toggleAlert('Uh oh. Something went wrong.', 'danger');
    } finally {
      setDisabled(false);
      reset();
      setSubmittedOnce(false); // Allow future submissions
    }
  };

  return (
    <Container className='find-me-container'>
      <Row>
        <Col md={12} className="home-about-social">
          <h1>FIND ME ON</h1>
          <p>Feel free to <span className="purple">connect </span>with me</p>
          <ul className="home-about-social-links">
            <li className="social-icons">
              <a href="https://github.com/saroopskesav" target="_blank" rel="noreferrer" className="icon-colour home-social-icons"><AiFillGithub /></a>
            </li>
            <li className="social-icons">
              <a href="https://x.com/kesavsaroop" target="_blank" rel="noreferrer" className="icon-colour home-social-icons"><AiOutlineTwitter /></a>
            </li>
            <li className="social-icons">
              <a href="https://www.linkedin.com/in/saroop-s-kesav-62a974181" target="_blank" rel="noreferrer" className="icon-colour home-social-icons"><FaLinkedinIn /></a>
            </li>
            <li className="social-icons">
              <a href="https://www.instagram.com/inevitable.soul_" target="_blank" rel="noreferrer" className="icon-colour home-social-icons"><AiFillInstagram /></a>
            </li>
            <li className="social-icons">
              <a href="mailto:contact@saroopskesav.com" target="_blank" rel="noreferrer" className="icon-colour home-social-icons"><AiFillMail /></a>
            </li>
          </ul>
        </Col>
      </Row>

      <div className="ContactForm">
        <div className="container">
          <div className="row">
            <div className="col-12 text-center">
              <div className="contactForm">
                <form id="contact-form" onSubmit={handleSubmit(onSubmit)} noValidate>
                  <div className="row formRow">
                    <div className="col-6">
                      <input
                        type="text"
                        name="name"
                        {...register('name', {
                          required: { value: true, message: 'Please enter your name' },
                          maxLength: { value: 30, message: 'Please use 30 characters or less' },
                        })}
                        className="form-control formInput"
                        placeholder="Name"
                      />
                      {errors.name && <span className="errorMessage">{errors.name.message}</span>}
                    </div>
                    <div className="col-6">
                      <input
                        type="email"
                        name="email"
                        {...register('email', {
                          required: true,
                          pattern: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
                        })}
                        className="form-control formInput"
                        placeholder="Email address"
                      />
                      {errors.email && <span className="errorMessage">Please enter a valid email address</span>}
                    </div>
                  </div>

                  <div className="row formRow">
                    <div className="col">
                      <input
                        type="text"
                        name="subject"
                        {...register('subject', {
                          required: { value: true, message: 'Please enter a subject' },
                          maxLength: { value: 75, message: 'Subject cannot exceed 75 characters' },
                        })}
                        className="form-control formInput"
                        placeholder="Subject"
                      />
                      {errors.subject && <span className="errorMessage">{errors.subject.message}</span>}
                    </div>
                  </div>

                  <div className="row formRow">
                    <div className="col">
                      <textarea
                        rows={3}
                        name="message"
                        {...register('message', { required: true })}
                        className="form-control formInput"
                        placeholder="Message"
                      />
                      {errors.message && <span className="errorMessage">Please enter a message</span>}
                    </div>
                  </div>

                  <button className="submit-btn btn btn-primary" disabled={disabled} type="submit">
                    Submit
                  </button>
                </form>
              </div>
            </div>
          </div>
        </div>

        {alertInfo.display && (
          <div className={`alert alert-${alertInfo.type} alert-dismissible mt-5`} role="alert">
            {alertInfo.message}
            <button
              type="button"
              className="btn-close"
              data-bs-dismiss="alert"
              aria-label="Close"
              onClick={() => setAlertInfo({ display: false, message: '', type: '' })}
            ></button>
          </div>
        )}
      </div>
    </Container>
  );
};

export default ContactForm;
